import styled from "styled-components";

export const StyledSearchResultList = styled.ul`
  max-height: 560px;
  overflow-y: auto;
  list-style: none;
  padding: 0;
  margin: 0;
  padding-top: 11px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: var(--color-gray-200);
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
  }

  &::-webkit-scrollbar-thumb:window-inactive {
    background: rgba(0, 0, 0, 0.4);
  }
`;

export const StyledSearchResultItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 15px 15px 20px;

  &:not(:last-child) {
    border-bottom: 2px solid var(--color-gray-200);
  }

  @media (min-width: 768px) {
    padding: 10px 15px 0px 15px;
  }
`;

export const StyledLink = styled.a`
  display: inline-block;
  text-decoration: none;
  transition: 0.4s ease-in;
  color: var(--badge-link) !important;

  &:hover p {
    color: var(--primary);
  }

  &:hover {
    text-decoration: none;
    color: var(--primary) !important;
  }
`;

export const StyledInfoWrapper = styled.div`
  display: flex;
`;

export const StyledImageWrapper = styled.div`
  max-width: 61px;
  width: 100%;
  margin-right: 15px;
  align-self: flex-start;

  @media (min-width: 768px) {
    margin-right: 20px;
  }
`;

export const StyledSearchResultInfo = styled.div`
  padding-top: 5px;
`;

export const StyledBadges = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
`;

export const StyledBadge = styled.div`
  margin-right: 10px;
  margin-bottom: 10px;

  @media (min-width: 768px) {
    margin-bottom: 15px;
    margin-right: 20px;
  }
`;
